module.exports = __webpack_public_path__ + "assets/images/frch2-video-preview2.jpg";